/**
 * @param {string} urlString
 * @param {string} variantId
 */
function withVariant(urlString, variantId) {
  if (!urlString || !variantId) return urlString;

  const url = new URL(urlString, window.location.origin);
  url.searchParams.set("variant", variantId);
  return `${url.pathname}${url.search}`;
}

/**
 * @param {{ swatchElement: Element | null, variantImageUrl: string | null, variantId: string | null }} params
 */
function updateDrawerRow({ swatchElement, variantImageUrl, variantId }) {
  const row = swatchElement?.closest(".shop-the-look-drawer__row");
  if (!row) return;

  if (variantImageUrl) {
    const image = row.querySelector(".shop-the-look-drawer__row-img");
    if (image instanceof HTMLImageElement) {
      image.src = variantImageUrl;
      image.srcset = "";
    }
  }

  if (!variantId) return;

  const selectors = [
    ".shop-the-look-drawer__row-media",
    ".shop-the-look-drawer__row-title a",
    ".shop-the-look-drawer__row-cta",
    ".shop-the-look-drawer__row-save",
  ];
  for (const selector of selectors) {
    const link = row.querySelector(selector);
    if (link instanceof HTMLAnchorElement) {
      link.href = withVariant(link.href, variantId);
    }
  }

  const saveButton = row.querySelector(".shop-the-look-drawer__row-save");
  if (saveButton instanceof HTMLElement) {
    saveButton.dataset.variantId = variantId;
    saveButton.dataset.epi = variantId;
  }
}

/**
 * @param {MouseEvent} event
 */
function handleDrawerSwatchClick(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const swatchElement = target.closest(".shop-the-look-drawer .color-swatch");
  if (!swatchElement) return;

  // Stop inline onclick="colorSwatchsChange(...)" so drawer swaps stay lightweight.
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const container = swatchElement.closest(".color-swatches");
  if (container) {
    for (const swatch of container.querySelectorAll(".color-swatch")) {
      swatch.classList.remove("active");
    }
  }
  swatchElement.classList.add("active");

  updateDrawerRow({
    swatchElement,
    variantImageUrl: swatchElement.getAttribute("data-variant-image"),
    variantId: swatchElement.getAttribute("data-variant-id"),
  });
}

document.addEventListener("click", handleDrawerSwatchClick, true);
